module.exports = __webpack_public_path__ + "static/media/bg-01.c92b2d76.jpg";